<nav class="main-nav-v1" [hidden]="!showMenu" id="mainMenu">
  <!-- Access Management: restricted sidebar (Users + Roles) -->
  <div class="pepi-menu" *ngIf="accessMgmtMode">
    <ul class="primary-menu" style="margin-top: 60px;">
      <li [class.active]="activePath === '/settings/manage-users-new'" routerLinkActive="active">
        <a routerLink="/settings/manage-users-new">
          <mat-icon class="mr-3" svgIcon="user-management"></mat-icon><span>User management</span>
        </a>
      </li>
      <li [class.active]="activePath === '/settings/audit-logs'" routerLinkActive="active">
        <a routerLink="/settings/audit-logs">
          <mat-icon class="mr-3" svgIcon="Logs"></mat-icon><span>Audit Logs</span>
        </a>
      </li>
    </ul>
  </div>
               
  <!-- Normal sidebar -->
  <ng-container *ngIf="!accessMgmtMode">
  <div class="pepi-menu" *ngIf="globals.product_type && globals.product_type=='emailapi'">
    <ul class="primary-menu" style="margin-top: 60px;">
      <!-- Dashboard -->
      <li [class.active]="activePath === '/dashboard' || activePath === '/home-dashboard' " routerLinkActive="active"
        *hasPermission="'email:Dashboard:view'">
        <a routerLink="/dashboard">
          <mat-icon class="mr-3" svgIcon="dashboard"></mat-icon><span>Dashboard</span>
        </a>
      </li>

      <!-- Live Feeds-->
      <li [class.active]="activePath === '/live'" routerLinkActive="active"
        *hasPermission="'email:LiveFeed:view'">
        <a routerLink="/live" title="Live Feed"><mat-icon class="mr-3" svgIcon="live-feed"></mat-icon> <span>Live
            feed</span></a>
      </li>

      <!-- Insights -->
      <ng-container *hasPermission="'email:Insights:view'">
      <li
        [class.active]="activePath?.indexOf('/insights')!==-1 && activePath !== undefined && activePath !== '/analytics/insights/funnel-performance/latency' && activePath !== '/analytics/insights/funnel-performance/spill-over'"
        routerLinkActive="active" class="has-sub submenu2" *ngIf="new_reporting">
        <a (click)="insightShowSubMenu()">
          <mat-icon class="mr-3" svgIcon="insight"></mat-icon>
          <span class="align-text-top">Insights</span>
          <!-- <sup> <span class="badge badge-primary">Beta</span> </sup> -->
          <i class="fas float-right m-0 medium-font"
            [ngClass]="insightSubMenuShow ? 'fa-caret-up' : 'fa-caret-down'"></i>
        </a>
        <ul class="secondary-menu" [ngClass]="insightSubMenuShow ? 'expand' : 'collapse'">
          <!-- <li [class.active]="activePath === '/analytics/insights'" routerLinkActive="active">
              <a routerLink="/analytics/insights">Dashboard</a>
            </li> -->

          <ng-container *hasPermission="'email:Insights:view'">
          <li [class.active]="activePath === '/analytics/insights/health-score'" routerLinkActive="active"
            *ngIf="showHealthScorePage">
            <a routerLink="/analytics/insights/health-score">Health score</a>
          </li>
          </ng-container>

          <ng-container *hasPermission="'email:Insights:view'">
            <li [class.active]="activePath === '/analytics/insights/funnel-performance'" routerLinkActive="active">
              <a routerLink="/analytics/insights/funnel-performance">Funnel performance</a>
            </li>
          </ng-container>

          <ng-container *hasPermission="'email:Insights:view'">            
            <li [class.active]="activePath === '/analytics/insights/engagement'" routerLinkActive="active"
              *ngIf="showEngagementPage ">
              <a routerLink="/analytics/insights/engagement">Engagement</a>
            </li>
          </ng-container>

          <ng-container *hasPermission="'email:Insights:view'">
            <li [class.active]="activePath === '/analytics/insights/deliverability/inbox-placement'"
              routerLinkActive="active" *ngIf="showInboxablePage">
              <a routerLink="/analytics/insights/deliverability/inbox-placement">Inbox placement</a>
            </li>
          </ng-container>

          <ng-container *hasPermission="'email:Insights:view'">            
            <li [class.active]="activePath === '/analytics/insights/deliverability/postmaster-dashboard'"
              routerLinkActive="active" *ngIf="showDeliverabilityPage">
              <a routerLink="/analytics/insights/deliverability/postmaster-dashboard">Google postmaster</a>
            </li>
          </ng-container>
        </ul>
      </li>
      </ng-container>
      <!-- Analytics -->
      <li
        [class.active]="activePath === '/analytics/insights/funnel-performance/spill-over' || activePath === '/analytics/insights/funnel-performance/latency' || activePath === '/analytics/usage-by-size' || activePath === '/analytics/mail-summary' || activePath === '/analytics/subaccount-analytics' || activePath === '/analytics/reports' || activePath === '/analytics/saved-schedule-report' ||  activePath?.includes('/analytics/reports') "
        routerLinkActive="active" *hasPermission="'email:Reports:view'">
        <a (click)="analyticsShowSubMenu()"><mat-icon class="mr-3" svgIcon="analytics"></mat-icon><span>Reports</span>
          <i class="fas float-right medium-font m-0" [ngClass]="analyticMenu ? 'fa-caret-up' : 'fa-caret-down'"></i>
        </a>
        <ul class="secondary-menu" [ngClass]="analyticMenu ? 'expand' : 'collapse'">
          <!-- <li [class.active]="activePath === '/analytics/mail-summary'" routerLinkActive="active" *ngIf='!isSubuserLogin || ( subUserRoleSubMenuAccess.indexOf("1") != -1 )' >
                <a routerLink="/analytics/mail-summary"  >Overview</a>
              </li> -->

          <!-- <li [class.active]="activePath === '/analytics/subaccount-analytics'" routerLinkActive="active"  *ngIf=' ( !isSubuserLogin || ( subUserRoleSubMenuAccess.indexOf("2") != -1 ) ) && (!subaccount) && (!hideSubUserMenu1) && (newMater) && accountStatus ' >
                  <a routerLink="/analytics/subaccount-analytics"> Subaccount Analytics </a>
              </li> -->

          <li [class.active]="activePath === '/analytics/reports' || activePath?.includes('/analytics/reports')"
            routerLinkActive="active"
            *hasPermission="'email:Reports:view'">
            <!-- <li routerLinkActive="active" *ngIf="new_reporting"> -->
            <a routerLink="/analytics/reports">Summary reports</a>
          </li>

          <li [class.active]="activePath === '/analytics/saved-schedule-report'" routerLinkActive="active"
            *hasPermission="'email:Reports:view'">
            <a routerLink="/analytics/saved-schedule-report">Schedule </a>
          </li>

          <ng-container *hasPermission="'email:Reports:view'">
            <li [class.active]="activePath === '/analytics/insights/funnel-performance/latency'" routerLinkActive="active"
              *ngIf="showLatencyPage">
              <a routerLink="/analytics/insights/funnel-performance/latency"> Latency </a>
            </li>
          </ng-container>

          <ng-container *hasPermission="'email:Reports:view'">
            <li [class.active]="activePath === '/analytics/insights/funnel-performance/spill-over'"
              routerLinkActive="active" *ngIf="showSpillOverPage">
            <a routerLink="/analytics/insights/funnel-performance/spill-over"> Spill over </a>
          </li>
          </ng-container>

          <ng-container *ngIf="falconide">
            <li [class.active]="activePath === '/analytics/usage-by-size'" routerLinkActive="active"
              *hasPermission="'email:Reports:view'">
              <a routerLink="/analytics/usage-by-size">Usage by size </a>
            </li>
          </ng-container>
        </ul>
      </li>
      <!-- Template Menu -->
      <li [class.active]="activePath === '/email-template'" routerLinkActive="active"  *hasPermission="'email:Template:view'" >
        <a routerLink="/email-template" title="Template"><mat-icon class="mr-3" svgIcon="template"></mat-icon>
          <span>Template</span></a>
      </li>

      <!-- Suppression -->
      <li [class.active]="activePath === '/suppression'" routerLinkActive="active"
        *hasPermission="'email:Suppression:view'">
        <a routerLink="/suppression" title="Suppressions"><mat-icon class="mr-3" svgIcon="suppression-list"></mat-icon>
          <span>Suppressions</span></a>
      </li>

      <!-- Email Marketing -->
      <ng-container *ngIf="( !falconPrepaid ) && ( !falconide )">
        <li [class.active]="activePath === '/email-marketing'" routerLinkActive="active"
          *hasPermission="'email:EmailMarketing:view'">
          <a routerLink="/email-marketing" title="Email Marketing">
            <mat-icon class="mr-3" svgIcon="marketing"></mat-icon>
            <span>Marketing</span>
          </a>
        </li>
      </ng-container>

      <!--Old pricing-->
      <ng-container *ngIf="!hideOldBillingMenu && accountStatus && (!pepi_enterprise)">
        <li [class.active]="activePath?.indexOf('/billings')!==-1 && activePath !== undefined" routerLinkActive="active"
          class="has-sub submenu2" [hidden]="!hideBillingMenu"
          *hasPermission="'email:Billing:view'">
          <a title="Billing" (click)="billingShowSubMenu()"><mat-icon class="mr-3" svgIcon="billing"></mat-icon><span>Billing</span>
            <i class="fas float-right m-0 medium-font"
              [ngClass]="billingSubMenuShow ? 'fa-caret-up' : 'fa-caret-down'"></i>
          </a>
          <ul [class.active]="activePath === '/billings/details' || activePath === '/billings/prepaid-billing'" class="secondary-menu"
            [ngClass]="billingSubMenuShow ? 'expand' : 'collapse'">
          <ng-container *ngIf="!hideBilling && !us_enterprise && !isDomesticClient">
            <li routerLinkActive="active === '/billings/details'"
              *hasPermission="'email:BillingDetails:view'">
              <a routerLink="/billings/details">Overview</a>
            </li>
          </ng-container>
          <ng-container *ngIf="!hideBilling && !us_enterprise && isDomesticClient">
            <li [class.active]="activePath === '/billings/prepaid-billing'" routerLinkActive="active"
              *hasPermission="'email:BillingDetails:view'">
              <a routerLink="/billings/prepaid-billing" *ngIf="!subaccount && !us_enterprise"> Overview </a>
            </li>
          </ng-container>
          <!-- for US entererprise billing page -->
          <ng-container *ngIf="!hideBilling && us_enterprise">
            <li [class.active]="activePath === '/billings/enterprise-billing'" routerLinkActive="active"
              *hasPermission="'email:EnterpriseBilling:view'">
              <a routerLink="/billings/enterprise-billing">Overview</a>
            </li>
          </ng-container>
          <ng-container *ngIf="(!subaccount) && (!hideSubUserMenu1) && (newMater) && accountStatus">
            <li
              [class.active]="activePath === '/billing/subaccount-log'|| activePath.indexOf('/billings/subaccount-log/')!==-1"
              routerLinkActive="active"
              *hasPermission="'email:SubaccountBilling:view'">
              <a routerLink="/billings/subaccount-log">Sub account
                <!--*ngIf="falconide && accountStatus && hideOldBillingMenu">Subaccount-->
              </a>
            </li>
          </ng-container>
          <li [class.active]="activePath === '/billings/credit-management'" routerLinkActive="active"
            *hasPermission="'email:CreditActivityLog:view'"
            [hidden]=" (hideCreditManagement || hideCreditManagement1 || postpaidClient )">
            <a routerLink="/billings/credit-management">Earned email Credits</a>
          </li>
          <!-- <li [class.active]="activePath === '/billings/bucketwise-billing'" routerLinkActive="active" *ngIf="(!isSubuserLogin || ( subUserRoleSubMenuAccess.indexOf('7') != -1 ) ) && falconide && !subaccount">
                <a routerLink="/billings/bucketwise-billing">Usage by size </a>
              </li> -->
        </ul>
      </li>
      </ng-container>

      <!--New Pricing postpaid client only billing section apart from subaccount logs-->
      <ng-container *ngIf="hideOldBillingMenu && accountStatus && (!preferred_accountStatus)">
        <li [class.active]="activePath?.indexOf('/billings')!==-1 && activePath !== undefined" routerLinkActive="active"
          class="has-sub submenu2" [hidden]="!hideBillingMenu"
          *hasPermission="'email:Billing:view'">
          <a title="Billing" (click)="billingShowSubMenu()"><mat-icon class="mr-3" svgIcon="billing"></mat-icon><span>Billing</span>
            <i class="fas float-right m-0 medium-font"
              [ngClass]="billingSubMenuShow ? 'fa-caret-up' : 'fa-caret-down'"></i>
          </a>
          <ul class="secondary-menu" [ngClass]="billingSubMenuShow ? 'expand' : 'collapse'">
          <ng-container *ngIf="!isDomesticClient">
            <li [class.active]="activePath === '/billings/postpaid-billing'" routerLinkActive="active"
              *hasPermission="'email:PostpaidBilling:view'">
              <a routerLink="/billings/postpaid-billing" *ngIf="!subaccount && !us_enterprise"> Overview </a>
            </li>
          </ng-container>
          <li [class.active]="activePath === '/billings/subaccount-billing'" routerLinkActive="active"
            *hasPermission="'email:SubaccountBilling:view'">
            <a routerLink="/billings/subaccount-billing" *ngIf="subaccount && !us_enterprise"> Overview </a>
          </li>
          <!-- for US entererprise billing page on local env for testing -->
          <!-- <li routerLinkActive="active">
                <a routerLink="/billings/enterprise-billing" *ngIf="us_enterprise">Billing</a>
              </li> -->
          <li [class.active]="activePath === '/billings/account-log'" routerLinkActive="active"
            *hasPermission="'email:BillingHistory:view'">
            <a routerLink="/billings/account-log" *ngIf="subaccount && accountStatus">Account log</a>
          </li>
          <li
            [class.active]="activePath === '/billings/subaccount-log' || activePath.indexOf('/billings/subaccount-log/')!==-1"
            routerLinkActive="active" *hasPermission="'email:SubaccountBilling:view'">
            <a routerLink="/billings/subaccount-log" *ngIf="(!subaccount) && (!hideSubUserMenu1)&& (newMater) && accountStatus">Sub
              accountt </a>
          </li>
          <li [class.active]="activePath === '/billings/postpaid-credit-management'" routerLinkActive="active"
            *hasPermission="'email:CashbackHistory:view'">
            <a routerLink="/billings/postpaid-credit-management" *ngIf="!subaccount && savings">Savings</a>
          </li>
          <ng-container *ngIf="(!falconPrepaid) && (!falconide)">
            <li [class.active]="activePath === '/billings/dedicated-ip'" routerLinkActive="active"
              *hasPermission="'email:DedicatedIP:view'">
              <a routerLink="/billings/dedicated-ip" *ngIf="(!hideSubUserMenu1) &&  ( newMater || subaccount )">Dedicated
                IP </a>
            </li>
          </ng-container>
          <!-- <li [class.active]="activePath === '/billings/bucketwise-billing'" routerLinkActive="active" *ngIf = "( ( !isSubuserLogin || ( subUserRoleSubMenuAccess.indexOf('7') != -1 ) ) ) && falconide && !subaccount">
                <a routerLink="/billings/bucketwise-billing">Usage by size </a>
              </li> -->
        </ul>
      </li>
      </ng-container>

      <!-- Settings -->
      <li [class.active]="activePath?.indexOf('/settings')!==-1 && activePath !== undefined" routerLinkActive="active"
        class="has-sub submenu3" *hasPermission="'email:Settings:view'">
        <a title="Settings" (click)="showSubMenu()"><mat-icon class="mr-3" svgIcon="setting"></mat-icon><span>Settings</span>
          <i class="fas float-right m-0 medium-font" [ngClass]="subMenuShow ? 'fa-caret-up' : 'fa-caret-down'"></i>
        </a>
        <ul class="secondary-menu" [ngClass]="subMenuShow ? 'expand' : 'collapse'">
          <ng-container *ngIf="accessMgmtMode; else fullSettingsMenu">
            <li [class.active]="activePath === '/settings/manage-users'" routerLinkActive="active">
              <a routerLink="/settings/manage-users">Users</a>
            </li>
          </ng-container>
          <ng-template #fullSettingsMenu>
          <li
            [class.active]="activePath === '/settings/general-settings' || activePath?.indexOf('/settings/domain')!==-1"
            routerLinkActive="active"
            *hasPermission="['email:SendingDomains:view', 'email:MailSettings:view', 'email:MailAlerts:view']">
            <a routerLink="/settings/general-settings">General</a></li>

          <li [class.active]="activePath === '/settings/inbound-parsing'" routerLinkActive="active"
            *hasPermission="'email:InboundParsing:view'"> <a
              routerLink="/settings/inbound-parsing">Inbound parsing </a></li>

          <li [class.active]="activePath === '/settings/sandbox'" routerLinkActive="active"
            *hasPermission="'email:Sandbox:view'"><a
              routerLink="/settings/sandbox">Sandbox</a></li>

          <li [class.active]="activePath === '/settings/integration'" routerLinkActive="active"
            *hasPermission="'email:Integration:view'"><a
              routerLink="/settings/integration">Integrations</a></li>


          <li [class.active]="activePath === '/settings/webhooks'" routerLinkActive="active"
            *hasPermission="'email:Webhooks:view'"><a
              routerLink="/settings/webhooks">Webhooks</a></li>

          <li [class.active]="activePath === '/settings/manage-tags'" routerLinkActive="active"
            *hasPermission="'email:ManageTags:view'"><a
              routerLink="/settings/manage-tags">Tags</a></li>

          <li [class.active]="activePath === '/settings/sub-accounts'" routerLinkActive="active"
            *hasPermission="'email:Subaccounts:view'">
            <a routerLink="/settings/sub-accounts"
              *ngIf="(!subaccount) && (!hideSubUserMenu1)&& (newMater) && accountStatus">Subaccounts</a>
          </li>

          <li [class.active]="activePath === '/settings/manage-users'" routerLinkActive="active"
            *hasPermission="'email:ManageUsers:view'">
            <a routerLink="/settings/manage-users">Manage users </a>
          </li>

          <!-- <li [class.active]="activePath === '/settings/template'" routerLinkActive="active"
            *ngIf="(!isSubuserLogin || ( subUserRoleSubMenuAccess.indexOf('22') != -1 ) )"><a
              routerLink="/settings/template">Templates</a>
          </li> -->


          <li [class.active]="activePath === '/settings/sub-user-management'" routerLinkActive="active"
            *hasPermission="'email:SubUsers:view'">
            <a routerLink="/settings/sub-user-management" [hidden]="hideSubUserMenu1"
              *ngIf="!hideSubUserMenu && accountStatus && !subaccount && (!newMater)">Sub-users</a>
          </li>

          <li [class.active]="activePath === '/settings/warmup'" routerLinkActive="active"
            *hasPermission="'email:WarmupPlan:view'"><a
              routerLink="/settings/warmup" [hidden]="hideWarmup">Warmup plan</a>
          </li>
          </ng-template>

        </ul>
      </li>

      <!-- Whatsapp Role Level Restriction -->
      <!-- <li routerLinkActive="active" class="has-sub submenu3" *ngIf=" ( !isSubuserLogin || ( subUserRoleMenuAccess.indexOf('8') != -1 ) ) && (whatsapp_enabled_sttaus)">
            <a title="Whatsapp"><i class="icon icon-whatsapp"></i><span class="level-0">Whatsapp</span></a>
            <ul>
              <li routerLinkActive="active" *ngIf="(!isSubuserLogin || ( subUserRoleSubMenuAccess.indexOf('26') != -1 ) )" ><a routerLink="/whatsapp/consent-management">Consent Management</a></li>
              <li routerLinkActive="active" *ngIf="(!isSubuserLogin || ( subUserRoleSubMenuAccess.indexOf('27') != -1 ) )" ><a routerLink="/whatsapp/templates">Templates</a></li>
              <li routerLinkActive="active" *ngIf="(!isSubuserLogin || ( subUserRoleSubMenuAccess.indexOf('28') != -1 ) )" ><a routerLink="/whatsapp/reports">Reports</a></li>
              <li routerLinkActive="active" *ngIf="(!isSubuserLogin || ( subUserRoleSubMenuAccess.indexOf('29') != -1 ) )" ><a routerLink="/whatsapp/settings">Settings</a></li>
              <li routerLinkActive="active" *ngIf="(!isSubuserLogin || ( subUserRoleSubMenuAccess.indexOf('30') != -1 ) )"><a routerLink="/whatsapp/webhooks">Webhooks</a></li>
            </ul>
          </li> -->



      <!-- Help -->
      <li routerLinkActive="active" [class.active]="activePath === '/help'">
        <!-- <a href="https://docs.pepipost.com" title="Help"> -->
        <a routerLink="/help" title="Help">
          <mat-icon class="mr-3" svgIcon="help"></mat-icon>
          <span class="level-0">Help</span>
        </a>
      </li>
    </ul>
    <!-- <div class="pepi-footer">
        <p class="copyright">&copy; 2015-{{currentYear}} Netcore Email API &reg;</p>
        <p class="my-1">All rights reserved.</p>
        <small><a href="https://pepipost.com/legal-security/" target="_blank">Privacy</a> and <a href="https://pepipost.com/terms-of-use/" target="_blank">Terms</a></small>
      </div> -->
  </div>

  <!-- SOIP menu started -->

  <div class="pepi-menu" *ngIf="globals.product_type && globals.product_type=='soip'">
    <ul class="primary-menu" style="margin-top: 60px;">

      <!-- Dashboard -->
      <li [class.active]="activePath === '/dashboard' || activePath === '/home-dashboard' " routerLinkActive="active"
        *hasPermission="'rcs:Dashboard:view'">
        <a routerLink="/dashboard">
          <mat-icon class="mr-3" svgIcon="dashboard"></mat-icon><span>Dashboard</span>
        </a>
      </li>

      <!-- Livefeed -->
      <ng-container *hasPermission="'rcs:LiveFeed:view'">
        <li [class.active]="activePath === '/live'" routerLinkActive="active">
          <a routerLink="/live" title="Reports"> <mat-icon class="mr-3" svgIcon="live-feed"> </mat-icon> <span>Live
              Feed</span></a>
        </li>
      </ng-container>

      <ng-container *hasPermission="'rcs:Reports:view'">
        <li [class.active]="activePath?.indexOf('/grcs/manage-reports')!==-1 && activePath !== undefined" routerLinkActive="active" class="has-sub submenu3">
          <a title="Reports"
           (click)="grcsShowReportSubMenu()"><mat-icon class="mr-3" svgIcon="analytics"></mat-icon><span>Reports</span>
            <i class="fas float-right m-0 medium-font" [ngClass]="grcsShowReportsSubMenu ? 'fa-caret-up' : 'fa-caret-down'"></i>
          </a>
        <ul class="secondary-menu" [ngClass]="grcsShowReportsSubMenu ? 'expand' : 'collapse'">
          <li [class.active]="activePath === '/grcs/manage-reports' || activePath?.includes('/grcs/manage-reports')" routerLinkActive="active">
            <!-- <li routerLinkActive="active" *ngIf="new_reporting"> -->
            <a routerLink="/grcs/manage-reports">Manage reports</a>
          </li>
          </ul>
        </li>
      </ng-container>

      <!-- Camp management -->
     <!--  <li [class.active]="activePath === '/grcs/campaign' || activePath === '/grcs/campaign' " routerLinkActive="active">
          <a routerLink="/grcs/campaign">
            <mat-icon class="mr-3" svgIcon="rcs"></mat-icon><span> Campaign Management</span>
          </a>
      </li> -->
      <li *hasPermission="'rcs:Campaign:view'" [class.active]="activePath === '/grcs/campaign' || activePath === '/grcs/campaign' " routerLinkActive="active">
          <a routerLink="/grcs/campaign">
            <mat-icon class="mr-3" svgIcon="marketing"></mat-icon><span>Campaign </span>
          </a>
      </li>

      <!-- RCS template -->
      <li *hasPermission="'rcs:Template:view'" [class.active]="activePath === '/grcs/template_wrapper'" routerLinkActive="active">
        <a routerLink="/grcs/template_wrapper">
          <mat-icon class="mr-3" svgIcon="template"></mat-icon><span>Template </span>
        </a>
    </li>

      <!-- Optin -->

      <!-- <li [class.active]="activePath === '/opt'" routerLinkActive="active"><a routerLink="/opt"><mat-icon class="mr-3"
            svgIcon="opt-in"></mat-icon> <span>Opt Out Management</span></a>
      </li> -->

      <!-- Blocklist -->
      <li [class.active]="activePath === '/blocklist'" routerLinkActive="active" *hasPermission="'rcs:Blocklist:view'">
        <a routerLink="/blocklist" title="Blocklist"><mat-icon class="mr-3" svgIcon="suppression-list"></mat-icon>
          <span>Blocklist</span></a>
      </li>

      <!-- Billing -->
      <li *hasPermission="'rcs:Billing:view'" [class.active]="activePath === '/billings/details'" routerLinkActive="active">
        <a routerLink="/billings/details" title="Billing"><mat-icon class="mr-3" svgIcon="billing"></mat-icon>
          <span>Billing</span></a>
      </li>

      <!-- Settings -->
      <ng-container *hasPermission="'rcs:Settings:view'">
        <li routerLinkActive="active" class="has-sub submenu3">
          <a title="Settings"
           (click)="rcsSettingsShowMenu()">
           <mat-icon class="mr-3" svgIcon="setting"></mat-icon><span>Settings</span>
            <i class="fas float-right m-0 medium-font" [ngClass]="showRCSSettingSubMenu ? 'fa-caret-up' : 'fa-caret-down'"></i>
          </a>
          <ul class="secondary-menu" [ngClass]="showRCSSettingSubMenu ? 'expand' : 'collapse'">
            <li [class.active]="activePath === '/settings/general-settings'" routerLinkActive="active">
              <a routerLink="/settings/general-settings" title="General"><span>General</span></a>
            </li>
            <li [class.active]="activePath === '/settings/account'" routerLinkActive="active">
              <a routerLink="/settings/account" title="Account"><span>Account</span></a>
            </li>
          </ul>
        </li>
      </ng-container>

    </ul>
  </div>
  <!-- end -->

  <!-- conv app menu started -->
  <div class="pepi-menu" *ngIf="globals.product_type && globals.product_type=='conv_apps'">

    <ul class="primary-menu" style="margin-top: 60px;">

      <!-- Dashboard -->
      <li [class.active]="activePath === '/dashboard' || activePath === '/home-dashboard' " routerLinkActive="active"
        *hasPermission="'whatsapp:Dashboard:view'">
        <a routerLink="/dashboard">
          <mat-icon class="mr-3" svgIcon="dashboard"></mat-icon><span>Dashboard</span>
        </a>
      </li>

      <!-- Livefeed -->
      <ng-container *hasPermission="'whatsapp:LiveFeed:view'">
        <li [class.active]="activePath === '/live'" routerLinkActive="active">
          <a routerLink="/live" title="Live Feed"><mat-icon class="mr-3" svgIcon="live-feed"></mat-icon> <span>Live
              feed</span></a>
        </li>
      </ng-container>

      <ng-container *hasPermission="'whatsapp:Reports:view'">
        <li [class.active]="activePath?.indexOf('/whatsapp/manage-reports')!==-1 && activePath !== undefined" routerLinkActive="active" class="has-sub submenu3">
          <a title="Reports"
           (click)="whatsappShowSubMenu()"><mat-icon class="mr-3" svgIcon="analytics"></mat-icon><span>Reports</span>
            <i class="fas float-right m-0 medium-font" [ngClass]="whatsappSubMenuShow ? 'fa-caret-up' : 'fa-caret-down'"></i>
          </a>
        <ul class="secondary-menu" [ngClass]="whatsappSubMenuShow ? 'expand' : 'collapse'">
          <li [class.active]="activePath === '/whatsapp/manage-reports' || activePath?.includes('/whatsapp/manage-reports')" routerLinkActive="active">
            <!-- <li routerLinkActive="active" *ngIf="new_reporting"> -->
            <a routerLink="/whatsapp/manage-reports">Manage reports</a>
          </li>

          </ul>
        </li>
      </ng-container>

      <!-- Camp management -->
      <li *hasPermission="'whatsapp:Campaign:view'" [class.active]="activePath === '/whatsapp/campaign' || activePath === '/whatsapp/campaign' "
        routerLinkActive="active">
        <a routerLink="/whatsapp/campaign">
          <mat-icon class="mr-3" svgIcon="marketing"></mat-icon><span>Campaigns </span>
        </a>
      </li>


      <!-- Template -->

      <ng-container *hasPermission="'whatsapp:Template:view'">
        <li [class.active]="activePath === '/settings/template'" routerLinkActive="active"><a
            routerLink="/settings/template"><mat-icon class="mr-3" svgIcon="template"></mat-icon>
            <span>Templates</span></a>
        </li>
      </ng-container>


      <!-- Consent -->
      <!--   <li [class.active]="activePath === '/whatsapp/consent-management'" routerLinkActive="active"  ><a routerLink="/whatsapp/consent-management"><mat-icon class="mr-3" svgIcon="opt-in"></mat-icon> <span>Optins management</span></a></li> -->

      <!-- Consent -->
      <li *hasPermission="'whatsapp:Blocklist:view'" [class.active]="activePath === '/opt'" routerLinkActive="active"><a routerLink="/opt"><mat-icon class="mr-3"
            svgIcon="opt-in"></mat-icon><span>Consent management</span></a></li>


      <!-- Billing  /billings/postpaid-billing -->
      <ng-container *hasPermission="'whatsapp:Billing:view'">
        <li *ngIf="wa_billing" [class.active]="activePath === '/billings/postpaid-billing'" routerLinkActive="active"><a
            routerLink="/billings/postpaid-billing"><mat-icon class="mr-3" svgIcon="billing"></mat-icon><span>Billing
            </span></a></li>
      </ng-container>

      <!-- Reports -->
      <!-- <li [class.active]="activePath === '/whatsapp/reports'" routerLinkActive="active" *ngIf="(!isSubuserLogin || ( subUserRoleSubMenuAccess.indexOf('22') != -1 ) )" ><a routerLink="/whatsapp/reports"><mat-icon class="mr-3" svgIcon="live-feed"></mat-icon> Live Feed</a>
      </li> -->

      <!-- Settings -->
      <ng-container *hasPermission="'whatsapp:Settings:view'">
        <li [class.active]="activePath?.indexOf('/settings/general-settings')!==-1 && activePath !== undefined && activePath?.indexOf('/whatsapp/mail-alert')!==-1" routerLinkActive="active" class="has-sub submenu3">
          <a title="Settings"
          (click)="whatsappSettingsShowMenu()"><mat-icon class="mr-3" svgIcon="setting"></mat-icon><span>Settings</span>
            <i class="fas float-right m-0 medium-font" [ngClass]="whatsappSettingSubMenuShow ? 'fa-caret-up' : 'fa-caret-down'"></i>
          </a>
          <ul class="secondary-menu" [ngClass]="whatsappSettingSubMenuShow ? 'expand' : 'collapse'">
            <!-- <li [class.active]="activePath === '/settings/general-settings'" routerLinkActive="active">
              <a routerLink="/settings/general-settings" title="Settings"> <span>General settings</span></a>
            </li> -->
            <li *hasPermission="'whatsapp:Settings:view'" [class.active]="activePath === '/whatsapp/account-settings'" routerLinkActive="active">
              <a routerLink="/whatsapp/account-settings" title="Account settings"><span>Account settings</span></a>
            </li>
            <li *hasPermission="'whatsapp:Settings:view'" [class.active]="activePath === '/whatsapp/manage-business-number'" routerLinkActive="active">
              <a routerLink="/whatsapp/manage-business-number" title="Business number"><span>Business number</span></a>
            </li>
            <li *hasPermission="'whatsapp:Settings:view'" [class.active]="activePath === '/whatsapp/mail-alert'" routerLinkActive="active">
              <a routerLink="/whatsapp/mail-alert" title="Mail alert"><span>Mail alert</span></a>
            </li>
            <li *hasPermission="'whatsapp:Settings:view'" [class.active]="activePath === '/whatsapp/manage-user'" routerLinkActive="active">
              <a routerLink="/whatsapp/manage-user" title="Manage user"><span>Manage user</span></a>
            </li>
            <li *hasPermission="'whatsapp:Settings:view'" [class.active]="activePath === '/whatsapp/integrations'" routerLinkActive="active">
              <a routerLink="/whatsapp/integrations" title="Integrations"><span>Integrations</span></a>
            </li>
          </ul>
        </li>
      </ng-container>
    </ul>
  </div>
  <div class="pepi-menu" *ngIf="globals.product_type && globals.product_type=='deflector'">
    <ul class="primary-menu" style="margin-top: 60px;">
      <!-- Dashboard -->
      <li [class.active]="activePath === '/dashboard' || activePath === '/home-dashboard' " routerLinkActive="active">
        <a routerLink="/dashboard">
          <mat-icon class="mr-3" svgIcon="dashboard"></mat-icon><span>Dashboard</span>
        </a>
      </li>

      <!-- Livefeed -->
      <li [class.active]="activePath === '/live'" routerLinkActive="active">
        <a routerLink="/live" title="Reports"> <mat-icon class="mr-3" svgIcon="live-feed"> </mat-icon> <span>Live
            Feed</span></a>
      </li>
    </ul>
  </div>

  <!-- sms menu -->
  <div class="pepi-menu" *ngIf="globals.product_type && globals.product_type === 'sms'">
    <ul class="primary-menu" style="margin-top: 60px;">
      <!-- Dashboard -->
      <li *hasPermission="'sms:Dashboard:view'" [class.active]="activePath === '/dashboard' || activePath === '/home-dashboard' " routerLinkActive="active">
        <a routerLink="/dashboard">
          <mat-icon class="mr-3" svgIcon="dashboard"></mat-icon><span>Dashboard</span>
        </a>
      </li>

      <!-- Livefeed -->
      <li *hasPermission="'sms:Livefeed:view'" [class.active]="activePath === '/sms/live-feed'" routerLinkActive="active">
        <a routerLink="/sms/live-feed" title="Reports">
          <mat-icon class="mr-3" svgIcon="live-feed"> </mat-icon>
          <span>Live feed</span>
        </a>
      </li>

      <!-- Templates -->
      <li *hasPermission="'sms:Template:view'" [class.active]="activePath === '/sms/templates'" routerLinkActive="active">
        <a routerLink="/sms/templates" title="Templates">
          <mat-icon class="mr-3" svgIcon="template"> </mat-icon>
          <span>Templates</span>
        </a>
      </li>

      <!-- Blocklist -->
      <li *hasPermission="'sms:Blocklist:view'" [class.active]="activePath === '/sms/blocklist'" routerLinkActive="active">
        <a routerLink="/sms/blocklist" title="Blocklist">
          <mat-icon class="mr-3" svgIcon="suppression-list"> </mat-icon>
          <span>Blocklist</span>
        </a>
      </li>

      <!-- Reports -->
      <ng-container *hasPermission="'sms:Reports:view'">
        <li [class.active]="activePath === '/sms/reports'" routerLinkActive="active" class="has-sub submenu3">
          <a title="Reports" (click)="toggleSMSSReportSubMenu()">
            <mat-icon class="mr-3" svgIcon="analytics"></mat-icon><span>Reports</span>
            <i class="fas float-right m-0 medium-font"
              [ngClass]="shouldShowSMSReportsSubMenu ? 'fa-caret-up' : 'fa-caret-down'"></i>
          </a>
          <ul class="secondary-menu" [ngClass]="shouldShowSMSReportsSubMenu ? 'expand' : 'collapse'">
            <!-- *ngIf="!isSubuserLogin" -->
            <li *hasPermission="'sms:Reports:view'" routerLinkActive="active" [class.active]="activePath === '/sms/reports/executive-summary'">
              <a routerLink="/sms/reports/executive-summary">Executive summary</a>
            </li>
            <!-- Legacy Delivery menu item removed; Delivery now points to the newer report (previously "Delivery (Beta)") -->
            <li *hasPermission="'sms:Reports:view'" routerLinkActive="active" [class.active]="activePath === '/sms/reports/delivery'">
              <a routerLink="/sms/reports/delivery">Delivery</a>
            </li>
            <li *hasPermission="'sms:Reports:view'" routerLinkActive="active" [class.active]="activePath === '/sms/reports/manage'">
              <a routerLink="/sms/reports/manage">Manage</a>
            </li>
          </ul>
        </li>
      </ng-container>
      <!-- Settings -->
      <li *hasPermission="'sms:Settings:view'" [class.active]="activePath === '/sms/settings'" routerLinkActive="active">
        <a routerLink="/sms/settings" title="Settings">
          <mat-icon class="mr-3" svgIcon="setting"> </mat-icon>
          <span>Settings</span>
        </a>
      </li>

      <!-- Reports -->
      <!-- <li [class.active]="activePath === '/sms/billing/overview'" routerLinkActive="active" class="has-sub submenu3">
        <a title="Billing" (click)="shouldShowBillingSubMenu = !shouldShowBillingSubMenu">
          <mat-icon class="mr-3" svgIcon="analytics"></mat-icon><span>Billing</span>
          <i class="fas float-right m-0 medium-font"
            [ngClass]="shouldShowBillingSubMenu ? 'fa-caret-up' : 'fa-caret-down'"></i>
        </a>
        <ul class="secondary-menu" [ngClass]="shouldShowBillingSubMenu ? 'expand' : 'collapse'">
          <li routerLinkActive="active" [class.active]="activePath === '/sms/billing/overview'">
            <a routerLink="/sms/billing/overview">Overview</a>
          </li>
        </ul>
      </li> -->

      <!-- Billing (SMS) - visible only if allowed -->
      <ng-container *ngIf="prepaidEnterprisePresent">
        <li *hasPermission="'sms:Billing:view'" [class.active]="activePath === '/sms/billing/overview'" routerLinkActive="active" class="has-sub submenu3">
          <a title="Billing" (click)="shouldShowBillingSubMenu = !shouldShowBillingSubMenu">
            <mat-icon class="mr-3" svgIcon="analytics"></mat-icon><span>Billing</span>
            <i class="fas float-right m-0 medium-font"
              [ngClass]="shouldShowBillingSubMenu ? 'fa-caret-up' : 'fa-caret-down'"></i>
          </a>
          <ul class="secondary-menu" [ngClass]="shouldShowBillingSubMenu ? 'expand' : 'collapse'">
            <li routerLinkActive="active" [class.active]="activePath === '/sms/billing/overview'">
              <a routerLink="/sms/billing/overview">Overview</a>
            </li>
          </ul>
        </li>
      </ng-container>

    </ul>
  </div>
</ng-container>
</nav>
